import { LOCALE_NAMES, LOCALES, type Locale } from '@indusketch/i18n';
import { useAuthStore } from '../features/auth/authStore.js';
import { useI18n } from './i18n.js';

/**
 * DE | EN | PL. The choice applies at once without reloading (an open project keeps its
 * unsaved changes) and is stored in the account when signed in.
 */
export function LanguageSwitcher({
  compact = false,
  menu = false,
}: {
  compact?: boolean;
  menu?: boolean;
}) {
  const { locale, m } = useI18n();
  const setLanguage = useAuthStore((s) => s.setLanguage);
  // Tablets: one small drop-down instead of three buttons in a crowded top bar.
  if (menu)
    return (
      <select
        className="input lang-menu"
        value={locale}
        aria-label={m.common.language}
        onChange={(e) => void setLanguage(e.target.value as Locale).catch(() => undefined)}
        data-testid="language-menu"
      >
        {LOCALES.map((l: Locale) => (
          <option key={l} value={l} lang={l}>
            {l.toUpperCase()}
          </option>
        ))}
      </select>
    );
  return (
    <div
      className="seg lang-switch"
      role="group"
      aria-label={m.common.language}
      data-testid="language-switcher"
    >
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          className={`btn${l === locale ? ' btn-active' : ''}`}
          aria-pressed={l === locale}
          title={LOCALE_NAMES[l]}
          lang={l}
          onClick={() => void setLanguage(l).catch(() => undefined)}
          data-testid={`language-${l}`}
        >
          {compact ? l.toUpperCase() : LOCALE_NAMES[l]}
        </button>
      ))}
    </div>
  );
}
